import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IResult } from 'app/shared/models/result.model';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDtoModule } from 'app/shared/models/security/dto-module.model';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { OrganizationService } from 'app/views/appviews/organization/organization.service';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { IDtoRetention } from 'app/shared/models/payroll/dto-retention.model';
import { PayrollService } from 'app/views/appviews/payroll.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoPayrollDetail } from 'app/shared/models/payroll/dto-payroll-detail.model';
import { IDtoRetentionEmail } from 'app/shared/models/payroll/dto-retention-email.model';

@Component({
    selector: 'app-modal-retentions',
    styleUrls: ['./modal-retentions.style.scss'],
    templateUrl: './modal-retentions.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalRetentionsComponet implements OnInit {
    private employees: IDtoRetentionEmail[];

    public onClose: Subject<IDtoRetentionEmail[]>;
    constructor(private bsModalRef: BsModalRef
        , private spinner: NgxSpinnerService
        , private formBuilder: FormBuilder
        , private payrollService: PayrollService
        , private configGeneral: AppConfig
        , private identityService: IdentityService) {
    }
    ngOnInit(): void {
        this.onClose = new Subject();
    }
    private isEmpty(value){
        return (value == null || value.length === 0);
      }
    private save(): void {
        console.log(this.employees);
        let isSave = true;
        this.employees.forEach((employee) => {
            if (this.isEmpty(employee.bank) || this.isEmpty(employee.methodPayment)) {
                isSave = false;
            }
        })
        if (isSave) {
            this.onClose.next(this.employees);
            this.bsModalRef.hide();
        } else {
            this.configGeneral.newToast('Error', 'Ingrese la información requerida para poder continuar', 'error');
        }
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'PayrollDetails';
        dto.module = 'Payroll';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
